import React from 'react';
import PropTypes from 'prop-types';
import { Radio as MuiRadio } from '@material-ui/core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Radio(_ref) {
  let {
    onChange,
    label,
    value,
    checked,
    ...rest
  } = _ref;
  const handleChange = () => {
    onChange(value);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "d-flex flex-row align-items-center",
    children: [/*#__PURE__*/_jsx(MuiRadio, {
      color: "primary",
      size: "medium",
      checked: checked,
      value: value,
      onChange: handleChange,
      ...rest
    }), label]
  });
}
Radio.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]).isRequired,
  checked: PropTypes.bool
};
export default Radio;